
<div class="flex flex-row min-w-screen min-h-screen items-center justify-center">
    <router-outlet></router-outlet>
</div>
